import React from 'react';

import {Modal, message } from 'antd';

import fetch from './../fetch';


const querySearchByResultId = (keywords) => {
    return fetch.get('jszgevalscore/getByResultId/' + keywords.id)
    .then(response => {
        return response.payload;
    })
}

const querySearchByTargetId = (keywords) => {
    return fetch.get('jszgevalscore/getByTargetId/' + keywords.id)
    .then(response => {
        return response.payload;
    })
}

const evalScoreInsert = (domain) => {
    return fetch.post('jszgevalscore/save' , domain)
    .then(response =>{
        return response
    })
}

const evalScoreStandard = (domain) => {
    return fetch.post('jszgevalscore/standard' , domain)
    .then(response =>{
        return response
    })
}

const onSubmit = (keywords) => {
    return fetch.get('jszgevalscore/submit/' + keywords.id)
    .then(response => {
        return response
    });
}

export default{
    querySearchByResultId,
    querySearchByTargetId,
    evalScoreInsert,
    evalScoreStandard,
    onSubmit
}